/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
import hanaLogo from "assets/img/hana-logo-blanco.png";
// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function IndexNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [collapseOut, setCollapseOut] = React.useState("");
  const [color, setColor] = React.useState("bg-info");
  React.useEffect(() => {
    window.addEventListener("scroll", changeColor);
    return function cleanup() {
      window.removeEventListener("scroll", changeColor);
    };
  }, []);
  const changeColor = () => {
    if (
      document.documentElement.scrollTop > 99 ||
      document.body.scrollTop > 99
    ) {
      setColor("bg-white"); // Use a new class or existing one that we control
    } else if (
      document.documentElement.scrollTop < 100 ||
      document.body.scrollTop < 100
    ) {
      setColor("navbar-transparent");
    }
  };
  const toggleCollapse = () => {
    document.documentElement.classList.toggle("nav-open");
    setCollapseOpen(!collapseOpen);
  };
  const onCollapseExiting = () => {
    setCollapseOut("collapsing-out");
  };
  const onCollapseExited = () => {
    setCollapseOut("");
  };
  const handleNavClick = (id) => (e) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with id '${id}' not found`);
    }
    setCollapseOpen(false);
    document.documentElement.classList.remove("nav-open");
  };
  const handleOverlayClick = () => {
    setCollapseOpen(false);
    document.documentElement.classList.remove("nav-open");
  };
  return (
    <>
      <Navbar className={"fixed-top " + color} color-on-scroll="100" expand="lg">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand href="#" onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); setCollapseOpen(false); document.documentElement.classList.remove("nav-open"); }} id="navbar-brand" className="d-flex align-items-center gap-2">
              <img src={hanaLogo} alt="Logo Hana" className="navbar-logo" />
            </NavbarBrand>
            <button
              aria-expanded={collapseOpen}
              className="navbar-toggler"
              onClick={toggleCollapse}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <Collapse
            className={"justify-content-end " + collapseOut}
            navbar
            isOpen={collapseOpen}
            onExiting={onCollapseExiting}
            onExited={onCollapseExited}
          >
            <Nav navbar>
              <NavItem>
                <NavLink href="#services" onClick={handleNavClick('services')}>Servicios</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#location" onClick={handleNavClick('location')}>Ubicación</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#team" onClick={handleNavClick('team')}>Nuestro Equipo</NavLink>
              </NavItem>
              {/* Oculto junto con la sección de reseñas: la API de Google no
                  autoriza el origen todavía. Descomentar los dos a la vez. */}
              {/* <NavItem>
                <NavLink href="#reviews" onClick={handleNavClick('reviews')}>Reseñas</NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink href="#offices" onClick={handleNavClick('offices')}>Instalaciones</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#contact" onClick={handleNavClick('contact')}>Contacto</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      {collapseOpen && (
        <div
          onClick={handleOverlayClick}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100vh',
            background: 'rgba(0,0,0,0.2)',
            zIndex: 1040
          }}
        />
      )}
    </>
  );
}
